import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/Ieltslogo.png'


const _hoisted_1 = { class: "ielts-page" }
const _hoisted_2 = { class: "footer" }
const _hoisted_3 = { class: "parts-table" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "part-title" }
const _hoisted_6 = { class: "question-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "part-progress"
}
const _hoisted_9 = {
  key: 0,
  class: "intro-overlay"
}

import { ref, onMounted, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { computed } from 'vue'
import { reactive, provide } from 'vue'
import { useExamSession } from '@/composables/useExamSession'
import { getListeningExam } from '@/api/listening'

import { watchEffect } from 'vue'

const TOTAL_QUESTIONS = 40
const QUESTIONS_PER_PART = 10

export default /*@__PURE__*/_defineComponent({
  __name: 'ListeningExamPage',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const answers = reactive({})
provide('answers', answers)
const activeQuestion = ref(1)
provide('activeQuestion', activeQuestion)

// ---- Backend session integration (autosave / restore / submit / timer) ----
// Degrades to local-only behavior when the user is not authenticated.
const buildAutosave = () =>
  Object.entries(answers)
    .filter(([, v]) => v !== undefined && v !== null && String(v).trim() !== '')
    .map(([k, v]) => ({ question_number: Number(k), value: v }))

const examSession = useExamSession({
  skill: 'listening',
  level: route.params.level,
  number: route.params.testId,
  fetchExam: getListeningExam,
  buildAutosave,
  buildSubmit: () => ({ answers: buildAutosave(), writing: [] }),
  hydrate: (detail) => {
    (detail.answers || []).forEach((a) => {
      answers[a.question_number] = a.value
    })
  },
})

provide('examSession', examSession)
provide('examTimeLeft', examSession.formattedTimeLeft)

onMounted(examSession.init)
watch(answers, () => examSession.scheduleAutosave(), { deep: true })

const goToQuestion = (n) => {
  activeQuestion.value = n

  const targetPart = getPartByQuestion(n)

  if (targetPart !== activePart.value) {
    goToPart(targetPart)
  }
}
const getPartByQuestion = (q) => {
  return Math.ceil(q / QUESTIONS_PER_PART)
}

const getPartQuestions = (part) => {
  const start = (part - 1) * QUESTIONS_PER_PART + 1
  const end = part * QUESTIONS_PER_PART
  return Array.from({ length: end - start + 1 }, (_, i) => start + i)
}
const activePart = computed(() => {
  if (route.path.includes('part-2')) return 2
  if (route.path.includes('part-3')) return 3
  if (route.path.includes('part-4')) return 4
  return 1
})

const goToPart = (part) => {
  const base = `/listening-exam/${route.params.level}/${route.params.testId}`

        
  const startQuestion = (part - 1) * QUESTIONS_PER_PART + 1
  activeQuestion.value = startQuestion

  if (part === 1) {
    router.push(base)
  } else {
    router.push(`${base}/part-${part}`)
  }
}




const showIntroOverlay = ref(true)

const startTest = () => {
  showIntroOverlay.value = false
}




//  navigation
const nextQuestion = () => {
  if (activeQuestion.value < TOTAL_QUESTIONS) {
    goToQuestion(activeQuestion.value + 1)
  }
}

const prevQuestion = () => {
  if (activeQuestion.value > 1) {
    goToQuestion(activeQuestion.value - 1)
  }
}
const getAnsweredCount = (part) => {
  const start = (part - 1) * 10 + 1
  const end = part * 10

  let count = 0

  for (let i = start; i <= end; i++) {
    if (answers[i] && answers[i].toString().trim() !== '') {
      count++
    }
  }

  return count
}
watchEffect(() => {
  const part = activePart.value
  const start = (part - 1) * QUESTIONS_PER_PART + 1
  const end = part * QUESTIONS_PER_PART

  if (
    activeQuestion.value < start ||
    activeQuestion.value > end
  ) {
    activeQuestion.value = start
  }
})



return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"header d-flex justify-content-between align-items-center px-4\" data-v-43ba345e><div class=\"d-flex align-items-center gap-1\" data-v-43ba345e><div class=\"logo\" data-v-43ba345e><img src=\"" + _imports_0 + "\" alt=\"IELTS Logo\" data-v-43ba345e></div><div data-v-43ba345e><div class=\"fw-bold\" style=\"font-weight:700;\" data-v-43ba345e>Test taker ID</div><div class=\"audio\" data-v-43ba345e><i class=\"fa-solid fa-volume-high fa-2xs\" data-v-43ba345e></i><span class=\"audio-text\" data-v-43ba345e>Audio is Playing</span></div></div></div><div class=\"icons\" data-v-43ba345e><i class=\"fa-solid fa-signal no-hover\" data-v-43ba345e></i><i class=\"fa-regular fa-bell\" data-v-43ba345e></i><i class=\"fa-solid fa-bars\" data-v-43ba345e></i></div></div>", 1)),
    _createVNode(_component_router_view),
    _createElementVNode("div", { class: "floating-nav" }, [
      _createElementVNode("button", {
        class: "nav-btn",
        onClick: prevQuestion
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("svg", {
          viewBox: "0 0 24 24",
          class: "arrow-icon"
        }, [
          _createElementVNode("path", { d: "M15 18l-6-6 6-6" })
        ], -1)
      ]))]),
      _createElementVNode("button", {
        class: "nav-btn dark",
        onClick: nextQuestion
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("svg", {
          viewBox: "0 0 24 24",
          class: "arrow-icon"
        }, [
          _createElementVNode("path", { d: "M9 6l6 6-6 6" })
        ], -1)
      ]))])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (part) => {
          return _createElementVNode("div", {
            key: part,
            class: _normalizeClass(["part-box-footer", { active: activePart.value === part }]),
            onClick: ($event: any) => (goToPart(part))
          }, [
            _createElementVNode("div", _hoisted_5, " Part " + _toDisplayString(part), 1),
            _createElementVNode("div", _hoisted_6, [
              (activePart.value === part)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(getPartQuestions(part), (n) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: n,
                      class: _normalizeClass(["q-cell", { active: activeQuestion.value === n }]),
                      onClick: _withModifiers(($event: any) => (goToQuestion(n)), ["stop"])
                    }, _toDisplayString(n), 11, _hoisted_7))
                  }), 128))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(getAnsweredCount(part)) + " of 10 ", 1))
            ])
          ], 10, _hoisted_4)
        }), 64))
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "footer-check" }, [
        _createElementVNode("div", { class: "check-box" }, [
          _createElementVNode("i", { class: "fa-solid fa-check" })
        ])
      ], -1))
    ]),
    (showIntroOverlay.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", { class: "intro-box" }, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "headphone-icon" }, [
              _createElementVNode("i", { class: "fa-solid fa-headphones" })
            ], -1)),
            _cache[5] || (_cache[5] = _createElementVNode("p", { class: "intro-text" }, " You will be listening to an audio clip during this test. You will not be permitted to pause or rewind the audio while answering the questions. ", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "intro-subtext" }, " To continue, click Play. ", -1)),
            _createElementVNode("button", {
              class: "play-btn",
              onClick: startTest
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "fa-solid fa-circle-play" }, null, -1),
              _createTextVNode(" Play ", -1)
            ]))])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})